<!--ptw总结-->
<template>
  <div style="width: 100%; height: 100%; position: absolute">
    <h1
      style="width: 100%; height: 70px; position: absolute; color: white; font-weight: bold; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
      Permit-to-Work (PTW) Status
      <div class="select"
           style="position: absolute; right: 5%; z-index: 9;width: 13%;display: inline-block">
        <el-select v-model="default_tag"
                   placeholder="请选择" popper-class="optionsContent"
                   @change="switch_tag">
          <el-option
            v-for="item in multi_tags"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </h1>
    <div class="submit_container" @click="showDetail">
      <div class="inner sub_num">
        {{ submit_num.toLocaleString() }}
      </div>
      <div class="inner">
        Submitted
      </div>
    </div>
    <div v-if="dataNotNull" key="1" class="ptwDiv"
         style="width: 100%; height: 663px; position: absolute; bottom: 0">
      <div class="container1" style="height: 100%;"></div>
    </div>
    <div v-else key="2"
         style="width: 100%; height: 793px; position: absolute; bottom: 0; line-height: 793px; color: #6CF; font-size: 64px;">
      No Data !
    </div>
    <div class="daily_ptw1_detail" v-show="showflag" id="daily_ptw1_detail">
      <h1
        style="width: 100%; height: 70px; position: absolute; color: #333; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
        Permit-to-Work (PTW) Status
        <div class="select"
             style="position: absolute; left: 50%; z-index: 9;width: 15%;display: inline-block">
          <el-select v-model="default_tag"
                     placeholder="请选择" popper-class="optionsContent"
                     @change="switch_tag">
            <el-option
              v-for="item in multi_tags"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </h1>
      <div class="close_img_gentry" @click="detailClose"></div>
      <div class="ptwDiv1" style="margin-top:100px; width: 100%; height: 540px">
        <el-collapse accordion>
          <el-collapse-item title="Approved">
            <div class="approved_container">
              <div class="approve_content">
                <div>Approved</div>
                <div class="item_type">
                  <div class="type_con">Contractor</div>
                  <div class="type_cnt">Cnt</div>
                </div>
                <div class="item_type" v-for="(item, index) in approved_data.list"
                     :key="'approve_' + index">
                  <div class="type_con">{{ item.contractor_name }}</div>
                  <div class="type_cnt">{{ item.count }}</div>
                </div>
              </div>
              <div class="pending_content">
                <div>Pending</div>
                <div class="item_type">
                  <div class="type_con">Contractor</div>
                  <div class="type_cnt">Cnt</div>
                </div>
                <div class="item_type" v-for="(item, index) in pending_data.list"
                     :key="'approve_' + index">
                  <div class="type_con">{{ item.contractor_name }}</div>
                  <div class="type_cnt">{{ item.count }}</div>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item title="Rejected">
            <div class="rejected_content">
              <div class="item_type">
                <div class="type_con">Contractor</div>
                <div class="type_cnt">Cnt</div>
              </div>
              <div class="item_type" v-for="(item, index) in rejected_data.list"
                   :key="'approve_' + index">
                <div class="type_con">{{ item.contractor_name }}</div>
                <div class="type_cnt">{{ item.count }}</div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item title="Closed">
            <div class="approved_container">
              <div class="approve_content">
                <div>Closed</div>
                <div class="item_type">
                  <div class="type_con">Contractor</div>
                  <div class="type_cnt">Cnt</div>
                </div>
                <div class="item_type" v-for="(item, index) in closed_data.list"
                     :key="'approve_' + index">
                  <div class="type_con">{{ item.contractor_name }}</div>
                  <div class="type_cnt">{{ item.count }}</div>
                </div>
              </div>
              <div class="pending_content">
                <div>Pending</div>
                <div class="item_type">
                  <div class="type_con">Contractor</div>
                  <div class="type_cnt">Cnt</div>
                </div>
                <div class="item_type" v-for="(item, index) in closed_pending_data.list"
                     :key="'approve_' + index">
                  <div class="type_con">{{ item.contractor_name }}</div>
                  <div class="type_cnt">{{ item.count }}</div>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {
  props: ['project_id'],
  name: "proj_ptw",
  data() {
    return {
      my_project_id: this.project_id,
      color: this.$store.state.color.chart_color,
      myChart: null,
      submit_num: 0,
      name: "ptws",
      dataNotNull: true,
      default_tag: "Daily",
      multi_tags: [
        {label: "Monthly", value: "1"},
        {label: "Daily", value: "0"},
        {label: "Acc.", value: "2"},
      ],
      showflag: false,
      data: null,
      pending_data: {
        count: 0,
        list: []
      },
      approved_data: {
        count: 0,
        list: []
      },
      rejected_data: {
        count: 0,
        list: []
      },
      closed_data: {
        count: 0,
        list: []
      },
      closed_pending_data: {
        count: 0,
        list: []
      }
    }
  },

  methods: {
    switch_tag(label) {
      this.getData(label)
    },
    init() {
      // this.$root.charts.push(this.myChart)
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
    init_chart() {
      let that = this
      this.myChart = echarts.init(document.querySelector('.ptwDiv .container1'))
      this.myChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          formatter: function (params) {
            return params[1].name + ':  ' + Math.round(params[2].value * 120 / params[0].value) + '%';
          },
          textStyle: {
            fontSize: '40'
          }
        },
        grid: {
          left: 330
        },
        xAxis: {
          type: 'value',
          show: false,
          axisLabel: {
            formatter: '{value}'
          }
        },
        yAxis: {
          type: 'category',
          inverse: true,
          data: ['Pending', 'Approved', 'Rejected', 'Closed'],
          axisLine: {
            show: true,
            lineStyle: {
              color: '#6CF'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            margin: 15,
            show: true,
            textStyle: {
              color: '#FFF',
              fontSize: 42
            }
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            name: '总计',
            type: 'bar',
            barGap: '-100%',
            barWidth: '60%',
            label: {
              normal: {
                show: false,
                color: '#6cf',
                position: 'Right',
              }
            },
            itemStyle: {
              normal: {
                color: '#00000000',
                borderColor: '#999',
                borderWidth: '0',
              }
            },
            data: []
          },
          {
            name: '总计',
            type: 'bar',
            barGap: '-100%',
            barWidth: '60%',
            label: {
              normal: {
                show: true,
                color: '#6cf',
                position: 'right',
                formatter: '{c}',
                textStyle: {
                  fontSize: 42
                }
              }
            },
            itemStyle: {
              normal: {
                color: '#00000000',
              }
            },
            data: []
          },
          {
            name: '申请',
            type: 'bar',
            barWidth: '60%',
            data: [],
            label: {
              normal: {
                show: false,
                formatter: '{b}'
              }
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  return that.color[params.dataIndex]
                },
              }
            },
          }
        ]
      })
      this.myChart.showLoading({
        text: '',
        color: '#66CCFF',
        maskColor: 'rgba(255, 255, 255, 0)',
      });
    },
    detailClose() {
      this.showflag = false
    },
    showDetail() {
      this.showflag = true
    },
    formatWidth(str, width) {
      str += ''
      if (str.length < width)
        return this.formatWidth('0' + str, width)
      else
        return str
    },
    analysisResult(result) {
      this.submit_num = 0
      this.pending_data.count = 0
      this.pending_data.list = []
      this.approved_data.count = 0
      this.approved_data.list = []
      this.rejected_data.count = 0
      this.rejected_data.list = []
      this.closed_data.count = 0
      this.closed_data.list = []
      this.closed_pending_data.count = 0
      this.closed_pending_data.list = []
      var ptws = [
        {name: 'Pending', value: 0},
        {name: 'Approved', value: 0},
        {name: 'Rejected', value: 0},
        {name: 'Closed', value: 0}
      ]
      var assists = []
      var totle = []
      var total = 0
      var assist = 0
      var apply = 0

      for (var i in result) {
        var count = result[i].count
        var status = result[i].status
        var con_name = result[i].short_name
        this.submit_num += parseInt(count)
        if (status == 'Submitted') {
          total += parseInt(count)
          ptws[0].value += parseInt(count)
          this.pending_data.count += parseInt(count)
          this.pending_data.list.push({contractor_name: con_name, count: parseInt(count)})
        } else if (status == 'Approved') {
          total += parseInt(count)
          ptws[1].value += parseInt(count)
          this.approved_data.count += parseInt(count)
          this.approved_data.list.push({contractor_name: con_name, count: parseInt(count)})
        } else if (status == 'Rejected') {
          total += parseInt(count)
          ptws[2].value += parseInt(count)
          this.rejected_data.count += parseInt(count)
          this.rejected_data.list.push({contractor_name: con_name, count: parseInt(count)})
        } else if (status == 'Closed') {
          total += parseInt(count)
          ptws[3].value += parseInt(count)
          this.closed_data.count += parseInt(count)
          this.closed_data.list.push({contractor_name: con_name, count: parseInt(count)})
        } else {
          // pending closed
          ptws[3].value += parseInt(count)
          total += parseInt(count)
          this.closed_pending_data.count += parseInt(count)
          this.closed_pending_data.list.push({contractor_name: con_name, count: parseInt(count)})
        }
      }
      var cover = total * 1.1
      var covers = []
      total *= 1.2
      assist = total / 5
      for (var i in ptws) {
        var name = ptws[i].name
        var value = parseInt(ptws[i].value) + assist
        assists.push({name: name, value: value})
        totle.push({name: name, value: total})
        covers.push({name: name, value: cover})
      }
      return {ptws: ptws, assists: assists, totle: totle, assist: assist, covers: covers}

    },
    getData(period) {
      var that = this
      let postData = {
        project_id: this.my_project_id,
        period: period,
        user: window.localStorage.getItem("token_key"),
        // token: window.localStorage.getItem('token')
        token: "lalala"
      }
      axios.post(this.$store.getters.getCmsServer + "DBProjPTWStatusCon", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        // this.myChart.hideLoading()
        if (errNo == "0") {
          this.dataNotNull = true
          that.$nextTick().then(() => {
            that.init_chart()
            that.myChart.hideLoading()
            var result = resp.data.result;
            this.data = result
            var data = this.analysisResult(result)
            this.myChart.setOption({
              series: [
                {
                  data: data.totle
                },
                {
                  data: data.assists,
                  label: {
                    normal: {
                      show: true,
                      color: '#6cf',
                      position: 'right',
                      formatter: function (params) {
                        return parseInt(params.value) - parseInt(data.assist);
                      }
                    }
                  },
                },
                {
                  data: data.ptws
                }
              ]
            })
          })
        } else {
          this.dataNotNull = false
        }
      }).catch(error => {
        alert(error)
        this.myChart.hideLoading()
        this.dataNotNull = false
      })
    },
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
  },
  mounted() {
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.my_project_id = "3177"
    }
    this.getData('0')

  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.submit_container {
  width 90%
  left 5%
  text-align center
  overflow: hidden;
  height 110px
  position absolute
  top 90px
  font-size 80px
  color white
}

.inner {
  display inline
}

.sub_num {
  font-size 96px
}

.daily_ptw1_detail {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  position: absolute;
  width: 90%;
  height: 80%;
  left: 5%;
  top: 12%;
  text-align: left;
  font-size: 40px;
  z-index: 1000;
  color #333333
}

.el-collapse-item__header {
  font-size 36px
  height 80px
  line-height 80px
  display inline
  margin-left 30px
  background-color rgb(248, 248, 248)
}

.approved_container {
  width 100%
  display flex
  max-height 330px
  overflow scroll
  font-size 32px
}

.approve_content, .pending_content {
  width 50%
  display flex
  flex-direction column
  text-align center
}

.rejected_content {
  width 100%
  max-height 330px
  overflow scroll
  display flex
  font-size 32px
  flex-direction column
  text-align center
}

.item_type {
  display flex
  width 100%
  height 60px
}

.type_con {
  flex 3
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.type_cnt {
  flex 1
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.el-collapse-item__wrap {
  background-color rgb(248, 248, 248)
}

.el-collapse-item__content {
  background-color rgb(248, 248, 248)
  font-size 32px
  margin-left 40px
  margin-right 40px
}
</style>



// WEBPACK FOOTER //
// src/components/safety_manage/proj_ptw.vue